var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"AdminList"},[_c('box',{attrs:{"title":_vm.$t('adminList')}},[_c('div',{},[_c('v-data-table',{attrs:{"dense":"","headers":_vm.headers,"items":_vm.list,"item-key":"","footer-props":{
          'items-per-page-options': [5, 10, 15, 50, 100, -1],
          'items-per-page-text': _vm.$t('rowsPerPage'),
          'show-first-last-page': true,
        }},on:{"click:row":_vm.handleClick},scopedSlots:_vm._u([{key:"item.AdminSectionName",fn:function(ref){
        var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.getAdminSectionName(item))+" ")]}}])})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }